export enum NotificationStatus {
  read = 'read',
  unread = 'unread',
}
